// Отдельный модуль, а не соседство с `useContentLang`: тесты мокают тот модуль
// целиком, и хук подсказок пропадал бы из-под всех полей контента.
import { useContext, useSyncExternalStore } from 'react'
import { ReactReduxContext } from 'react-redux'
import type { RootState } from '@/store'
import { pickMessages, useMessages, type Message, type Mirror } from '@/i18n'

const noSubscribe = () => () => undefined

/**
 * Тексты раздела на языке ПРАВКИ, а не интерфейса — для плейсхолдеров полей
 * контента: на английском слоте подсказка по-английски сразу говорит автору,
 * что он правит английскую версию. Без стора (поля вне редактора, тесты) —
 * язык интерфейса: эти же поля живут и там, где языка правки нет.
 */
export const useContentMessages = <T extends Record<string, Message>>(m: {
  ru: T
  en: Mirror<T>
}): T => {
  const ui = useMessages(m)
  const ctx = useContext(ReactReduxContext)
  const lang = useSyncExternalStore(ctx ? ctx.store.subscribe : noSubscribe, () =>
    ctx ? (ctx.store.getState() as RootState).editor?.contentLang : undefined,
  )
  return lang ? pickMessages(m, lang) : ui
}
